export default function PageDecoration() {
    return (
        <div className="absolute inset-0 pointer-events-none overflow-hidden">
            <div className="absolute -top-32 -left-32 w-96 h-96 bg-gradient-to-br from-violet-400/15 to-purple-400/5 rounded-full blur-3xl"></div>
            <div className="absolute -top-24 -right-24 w-80 h-80 bg-gradient-to-bl from-indigo-400/15 to-blue-400/5 rounded-full blur-3xl"></div>
        </div>
    );
}

